import { getAppBarPinnedAppIdsFromUserSettings } from "./getAppBarPinnedAppIdsFromUserSettings";
import type { MailboxInfo } from "owa-client-types";
import { isCapabilityEnabled } from "owa-capabilities";
import { m365AcquisitionsCapability } from "owa-capabilities-definitions/lib/m365AcquisitionsCapability";

export function isAppBarPinnedAppsEnabled(mailboxInfo?: MailboxInfo): boolean {
    return (isCapabilityEnabled(m365AcquisitionsCapability, mailboxInfo) &&
        !!getAppBarPinnedAppIdsFromUserSettings(mailboxInfo));
}
